<template>
  <div class="view">
    <div class="bg-decoration">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
    </div>
    <div class="content-wrapper">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ViewPage"
  }
</script>

<style scoped lang="scss">
  .view {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 20px;
    position: relative;
    
    .bg-decoration {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: none;
      overflow: hidden;
      
      .circle {
        position: absolute;
        border-radius: 50%;
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.05) 0%, rgba(37, 99, 235, 0.03) 100%);
      }
      
      .circle-1 {
        width: 300px;
        height: 300px;
        top: -100px;
        right: -50px;
        animation: float 12s ease-in-out infinite;
      }
      
      .circle-2 {
        width: 200px;
        height: 200px;
        bottom: -50px;
        left: 10%;
        animation: float 15s ease-in-out infinite reverse;
      }
    }
    
    .content-wrapper {
      position: relative;
      z-index: 1;
      animation: fadeInUp 0.4s ease-out;
    }
  }
  
  @keyframes float {
    0%, 100% {
      transform: translateY(0) rotate(0deg);
    }
    50% {
      transform: translateY(-20px) rotate(5deg);
    }
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>
